// Sin zod: lo usa el shell de la web, que entra en el bundle inicial (RNF-PERF-05).
const PY_PHONE = /^\+595(\d{3})(\d{3})(\d{3,4})$/;
/** Teléfono para mostrar: los de Paraguay (+595) como se marcan en el país, `0981 456 789`. */
export function formatPhone(phone) {
    if (phone === null || phone === undefined || phone === '')
        return '';
    const py = PY_PHONE.exec(phone);
    if (py !== null)
        return `0${py[1] ?? ''} ${py[2] ?? ''} ${py[3] ?? ''}`;
    return phone;
}
//# sourceMappingURL=format.js.map